import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

const VIEWBOX_WIDTH = 40;
const VIEWBOX_HEIGHT = 28;

interface GiftIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const GiftIcon: React.FC<GiftIconProps> = ({
  size = 34,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  const width = size;
  const height = (size * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH;

  return (
    <Svg
      {...props}
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill="none"
    >
      <Path
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V13L6.35036 13C4.90832 11.4105 4.87737 8.95124 6.41436 7.41425C7.95132 5.87729 10.4105 5.90821 12 7.35014V0H4ZM14 0V7.53646C14.014 7.52173 14.0283 7.50713 14.0427 7.49269C15.6237 5.91166 18.192 5.82801 19.7781 7.41412C21.3152 8.95116 21.2842 11.4105 19.842 13L40 13V4C40 1.79086 38.2091 0 36 0H14ZM40 15L15.4143 15L18.7073 18.2929L17.293 19.7071L14 16.4141V28H36C38.2091 28 40 26.2091 40 24V15ZM12 28V17.0566L9.75677 19.6536L8.24323 18.3462L11.1336 15L0 15V24C0 26.2091 1.79086 28 4 28H12ZM7.90715 11.7355C7.05825 10.8866 7.07155 9.58549 7.82858 8.82846C8.58561 8.07143 9.88667 8.05813 10.7356 8.90703C10.8456 9.01703 10.9799 9.25904 11.078 9.69368C11.172 10.1104 11.2101 10.6023 11.2126 11.0961C11.2145 11.4881 11.1939 11.8611 11.1683 12.1682C10.8612 12.1938 10.4883 12.2144 10.0962 12.2125C9.60246 12.21 9.11051 12.1719 8.6938 12.0779C8.25916 11.9798 8.01714 11.8455 7.90715 11.7355ZM18.3639 8.82833C17.6069 8.0713 16.3058 8.058 15.4569 8.9069C15.3469 9.0169 15.2126 9.25891 15.1145 9.69355C15.0205 10.1103 14.9824 10.6022 14.9799 11.0959C14.978 11.488 14.9986 11.861 15.0242 12.1681C15.3313 12.1937 15.7042 12.2143 16.0963 12.2123C16.59 12.2099 17.082 12.1717 17.4987 12.0777C17.9333 11.9797 18.1754 11.8453 18.2854 11.7353C19.1343 10.8864 19.121 9.58536 18.3639 8.82833Z"
        fill={colors[color]}
        fillRule="evenodd"
      />
    </Svg>
  );
};
